import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import React from "react";
import { FaPlus } from "react-icons/fa";
import { deleteCourseTypeApi, getCourseTypeApi } from "../../../Api/CourseType";
import toast from "react-hot-toast";
import { IconTrash } from "@tabler/icons-react";
import DeleteItem from "../DeleteItem";
import { useRef } from "react";
import { CourseTypeForm } from "./CourseTypeForm";
import SideModal from "../../general/Sidemodal";


interface Props {
    url: string;
}

type CourseTypeInterface = {
    id: string;
    name: string;
    parentId: string | null;
    durationType: string | null;
    fees: number;
    availability: string | null;
    timings: { id: string; courseTypeId: string; startime: string; endtime: string; updatedBy: string; updatedOn: string }[] | null;

};

export function CourseType({ url }: Props) {
    const navigate = useNavigate();

    const [courseTypes, setCourseTypes] = useState<CourseTypeInterface[]>([]);
    const [expandedRows, setExpandedRows] = useState<string[]>([]);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState<{ id: string } | null>(null);

    const handleApiCallClick = async () => {
        try {
            const fetchedData = await getCourseTypeApi(url) as CourseTypeInterface[];
            const formattedData = fetchedData.map((courseType: CourseTypeInterface) => ({
                ...courseType,
                timings: courseType.timings && courseType.timings.length > 0 ? courseType.timings.map((timing) => ({
                    ...timing,
                    startime: timing.startime.slice(0, -3),
                    endtime: timing.endtime.slice(0, -3),
                })) : [],
            }));
            setCourseTypes(formattedData as CourseTypeInterface[]);
        } catch (error) {
            toast.error("Failed to fetch Course data. Some problem occurred. Please try again.")
            console.error("API Error:", error);
        }
    };

    useEffect(() => {
        handleApiCallClick();
    }, []);

    const toggleRowExpansion = (courseTypeId: string) => {
        setExpandedRows((prevExpandedRows) =>
            prevExpandedRows.includes(courseTypeId)
                ? prevExpandedRows.filter((id) => id !== courseTypeId)
                : [...prevExpandedRows, courseTypeId]
        );
    };

    const filteredCourseType = courseTypes.filter(
        (item) => item.parentId === null
    );

    const [isFormOpen, setIsFormOpen] = useState(false);
    const [editId, setEditId] = useState<string | null>(null);

    function handleAddClick() {
        setEditId(null);
        setIsFormOpen(true);
    }

    const handleEditClick = (id: string) => {
        setEditId(id);
        setIsFormOpen(true);
    };

    const handleFormClose = () => {
        setIsFormOpen(false);
        setEditId(null);
        handleApiCallClick();
    };


    const handleDeleteClick = (id: string) => {
        setSelectedItem({ id });
        setIsModalOpen(true);
    };


    const confirmDelete = async () => {
        if (!selectedItem) return;

        try {
            await deleteCourseTypeApi(selectedItem.id, url);
            handleApiCallClick();
            toast.success("Deleted successfully!");
        } catch (error) {
            toast.error("Failed to delete." + error);
        } finally {
            setIsModalOpen(false);
            setSelectedItem(null);
        }
    };

    return (
        <div>
            <div className="px-2 md:px-4 mt-6">
                <div className='flex flex-row items-center '>
                    <h2 className="text-3xl font-bold text-blue-600 mb-5">Course Type</h2>

                    <button
                        type="button"
                        className=" w-fit px-3 py-2 mx-3 mb-4 tracking-wide text-white capitalize transition-colors duration-300 transform bg-blue-600 rounded-lg hover:bg-blue-500 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-80"
                        onClick={handleAddClick}
                    >
                        <FaPlus className="w-3 h-3" />
                    </button>
                </div>

                <input
                    type="text"
                    placeholder="Search by course type or subcategory"
                    className="w-full mb-6 p-2 border rounded-md focus:outline-none focus:ring focus:ring-blue-300"
                />
                <div className="overflow-x-auto">
                    <table className="w-full border divide-y divide-gray-200 dark:divide-gray-700 md:rounded-lg">
                        <thead className="bg-gray-50 dark:bg-gray-800">
                            <tr>
                                <th className="px-4 py-3.5 text-md font-normal text-left text-gray-500">Action</th>
                                <th className="px-4 py-3.5 text-md font-normal text-left text-gray-500">Course Type</th>
                                <th className="px-4 py-3.5 text-md font-normal text-left text-gray-500">Duration Type</th>
                                <th className="px-4 py-3.5 text-md font-normal text-left text-gray-500">Fees</th>
                                <th className="px-4 py-3.5 text-md font-normal text-left text-gray-500">Availability </th>
                                <th className="px-4 py-3.5 text-md font-normal text-left text-gray-500">Timings </th>
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200 dark:divide-gray-700 dark:bg-gray-900">
                            {filteredCourseType.map((courseType) => {
                                // const hasChildren = courseTypes.some((item) => item.parentId === courseType.id);

                                return (
                                    <React.Fragment key={courseType.id}>
                                        <tr className="hover:bg-gray-50">
                                            <td className="px-4 py-4 text-sm whitespace-nowrap">
                                                <div className="flex items-center gap-x-6">
                                                    <IconTrash
                                                        className="cursor-pointer text-gray-500 transition-colors duration-200 hover:text-red-500"
                                                        onClick={() => handleDeleteClick(courseType.id)}
                                                    />

                                                    <button
                                                        onClick={() => handleEditClick(courseType.id)}
                                                        className="text-gray-500 transition-colors duration-200 dark:hover:text-yellow-500 dark:text-gray-300 hover:text-yellow-500 focus:outline-none"
                                                    >
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            fill="none"
                                                            viewBox="0 0 24 24"
                                                            strokeWidth="1.5"
                                                            stroke="currentColor"
                                                            className="w-5 h-5"
                                                        >
                                                            <path
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                                d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
                                                            />
                                                        </svg>
                                                    </button>
                                                </div>
                                            </td>
                                            <td className="px-4 py-4 text-sm font-normal text-gray-700 whitespace-nowrap">
                                                <div className="flex justify-between items-center">
                                                    <span>{courseType.name}</span>
                                                </div>
                                            </td>
                                            <td className="px-4 py-4 text-sm font-normal text-gray-700 whitespace-nowrap">
                                                <div className="flex justify-between items-center">
                                                    <span>{courseType.durationType}</span>
                                                </div>
                                            </td>
                                            <td className="px-4 py-4 text-sm font-normal text-gray-700 whitespace-nowrap">
                                                <div className="flex justify-between items-center">
                                                    <span>{courseType.fees}</span>
                                                </div>
                                            </td>
                                            <td className="px-4 py-4 text-sm font-normal text-gray-700 whitespace-nowrap">
                                                <div className="flex justify-between items-center">
                                                    <span>{courseType.availability}</span>
                                                </div>
                                            </td>
                                            <td className="px-4 py-4 text-sm font-normal text-gray-700 whitespace-nowrap">
                                                <div className="flex justify-between items-center">
                                                    <span>{courseType.timings.length > 1 ? (
                                                        <button
                                                            className="text-blue-600 hover:underline"
                                                            onClick={() => toggleRowExpansion(courseType.id)}
                                                        >
                                                            {expandedRows.includes(courseType.id) ? 'Hide' : 'Show'}
                                                        </button>
                                                    ) : (
                                                        courseType.timings.map((avail) => `${avail.startime}-${avail.endtime}`).join(', ')
                                                    )}</span>
                                                </div>
                                            </td>
                                        </tr>

                                        {expandedRows.includes(courseType.id) && (
                                            <tr>
                                                <td colSpan={5} className="px-4 py-2">
                                                    <div>
                                                        <table className="w-full border-collapse border border-gray-200">
                                                            <thead className="bg-gray-200">
                                                                <tr>
                                                                    <th className="font-normal px-4 py-2 text-center text-gray-500">Start Time</th>
                                                                    <th className="font-normal px-4 py-2 text-center text-gray-500">End Time</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {courseType.timings.map((avail, availIndex) => (
                                                                    <tr key={availIndex} className="hover:bg-gray-50">
                                                                        <td className="border border-gray-300 px-4 py-2 text-center text-gray-500">
                                                                            {avail.startime}
                                                                        </td>
                                                                        <td className="border border-gray-300 px-4 py-2 text-center text-gray-500">
                                                                            {avail.endtime}
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}

                                    </React.Fragment>
                                );
                            })}
                        </tbody>
                    </table>
                </div>



                {/* <button onClick={handleAddClick} className="mb-5 mt-3 flex items-center justify-center px-6 py-2 font-medium tracking-wide text-white capitalize transition-colors duration-300 transform bg-blue-600 rounded-lg hover:bg-blue-500 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-80">
                    <FaPlus className="mr-2 font-medium " />
                    Sub Type
                </button> */}
            </div>
            {isModalOpen && (
                <DeleteItem onClose={() => setIsModalOpen(false)} onConfirm={confirmDelete} />
            )}

            <SideModal isOpen={isFormOpen} onClose={() => setIsFormOpen(false)}>
                <CourseTypeForm
                    url={url}
                    onClose={handleFormClose}
                    editId={editId}
                    onSaved={handleApiCallClick}
                />
            </SideModal>

        </div>
    );
}
